export enum InvoiceErrorEnum {
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  INVOICE_CONFIG_NOT_FOUND = "INVOICE_CONFIG_NOT_FOUND",
  PRODUCT_NOT_FOUND = "PRODUCT_NOT_FOUND",
  INVOICE_NOT_FOUND = "INVOICE_NOT_FOUND",
}

export interface CustomerInvoiceError {
  data?: {
    agencyName?: string;
  };
  errorCode?: number;
  message?: string;
}
